import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BonCfDTO} from '../../../core/dtos/boncfs-dto';
import {ValueDTO} from '../../../core/dtos/value-dto';
import {MenuItem} from 'primeng/api';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {CommandesService} from '../../../core/services/gestion-commandes/commandes.service';
import {GenericDatagridService} from '../../../core/services/generics/generic-datagrid.service';
import {UtilsService} from '../../../core/utils/utils.service';
import {
  EMAIL_STATUT,
  BCF_STATUT,
  DATEPICKER_FR,
  HELP_FOLDERS,
  RECEPTION_STATUT, HAS_GEF, MSG_KEY, MSG_SEVERITY
} from '../../../core/constants';
import {SearchSupplierWrapper} from '../../../core/suppliers/wrappers/search-supplier-wrapper';
import {SearchSupplier} from '../../../core/suppliers/search-supplier';
import {cloneDeep as _cloneDeep, uniqBy as _uniqBy} from 'lodash';
import {switchMap} from 'rxjs/operators';
import {BonCfDetailDTO} from '../../../core/dtos/boncf-detail-dto';
import {DomSanitizer} from '@angular/platform-browser';
import {saveAs as fs_saveAs} from 'file-saver';
import {BonReceptionDTO} from '../../../core/dtos/bon-reception-dto';
import {BonReceptionService} from '../../../core/services/entities/bon-reception.service';
import {Menu} from 'primeng/menu';
import {BoncfService} from "../../../core/services/entities/boncf.service";
import {MailHistoService} from "../../../core/services/entities/mail-histo.service";
import {FacturationService} from "../../../core/services/entities/facturation.service";
import {DxDataGridComponent} from "devextreme-angular";
import CustomStore from "devextreme/data/custom_store";
import {of, Subscription} from "rxjs";
import {Sort} from "../../../core/suppliers/generics/generic-request-supplier";
import {DevextremeService, FilterItem} from "../../../core/services/technique/devextreme.service";
import {WorkflowsService} from "../../../core/services/entities/workflows.service";
import {BoncfDetailService} from "../../../core/services/entities/boncf-detail.service";
import {MailHistoDTO} from "../../../core/dtos/mail-histo-dto";
import {GefAuditDto} from "../../../core/dtos/gef/gef-audit-dto";
import {GestionGefService} from "../../../core/services/gef/gestion-gef.service";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../../core/services/technique/toast.service";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-bc-receptions',
    templateUrl: './bc-receptions.component.html',
    styleUrls: ['./bc-receptions.component.scss'],
    standalone: false
})
export class BcReceptionsComponent implements OnInit, OnDestroy {

  BONCF_MAIL_STATUT = EMAIL_STATUT;
  receptionStatutCode = RECEPTION_STATUT;

  commandesReceptionnees: BonCfDTO[] = [];
  selectedBonCfs: BonCfDTO[] = [];
  totalRecords = 0;
  loadingTable: boolean = false;

  isDisabledGobackOption: boolean = false;

  // dialog edit
  bonCf: BonCfDTO;
  lignesBonCf: BonCfDetailDTO[] = [];
  displayEditDialog: boolean = false;
  displayDialogArticlesReception: boolean = false;
  dialogTitle = 'Détails';

  // items pour le filtre de sélection des listes de besoin
  filterItemsListeBesoin: ValueDTO[];
  // items pour le filtre de sélection des unités de production
  filterItemsUdp: ValueDTO[];
  // items pour le filtre de sélection des fournisseurs
  filterItemsFournisseur: ValueDTO[] = [];

  filterDatesLivraisons: Date[]; // Merci de le laisser undefined ! p-calendar fonctionne mal avec un tableau vide

  fr: any;

  nextSteps: MenuItem[] = [];

  selectedBonReception: BonReceptionDTO;
  /**
   * Selection des actions sur le bon de réception
   */
  brlActions: MenuItem[] = [
    {
      label: 'Voir le bon de réception',
      icon: 'fas fa-th-large',
      command: (event) => this.bonReceptionSvc.announceBonReceptionGridDxView(this.selectedBonReception)
    },
    {
      label: 'Calculé lors du choose action',
      icon: 'fas fa-ban',
      command: (event) => this.cancelBonReception()
    },
  ];

  @ViewChild("grid") grid: DxDataGridComponent;

  dataSource: CustomStore;
  allMode: string;
  checkBoxesMode: string;

  listesBesoinsIdsSelected: number[] = [];
  udpIdsSelected: number[] = [];
  fournisseursIdsSelected: number[] = [];
  articleFilter: string;
  bonLivraisonOrReceptionNumeroFilter: string;

  subMailsBonCfEnvoyes: Subscription;

  isActionDisabled: boolean = true;

  pathFile: string = HELP_FOLDERS.COMMANDES_FOURNISSEURS + '/bons-receptions';

  selectAll: boolean = false;
  numeroCommandeSelected: string;

  gefAuditListBonCommande: GefAuditDto[] = [];
  gefAuditListBonReception: GefAuditDto[] = [];

  constructor(public auth2Svc: Auth2Service,
              public commandesSvc: CommandesService,
              private bonReceptionSvc: BonReceptionService,
              private bonCfSvc: BoncfService,
              private gds: GenericDatagridService,
              public utils: UtilsService,
              public mailHistoSvc: MailHistoService,
              public domSanitizer: DomSanitizer,
              private dxSvc: DevextremeService,
              public wkfSvc: WorkflowsService,
              private bonCfDetailSvc: BoncfDetailService,
              public gefSvc: GestionGefService,
              private toastSvc: ToastService,
              private i8nSvc: InternationalizationService,
              private factuSvc: FacturationService) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'always';
  }


  ngOnInit() {
    this.loadingTable = true;
    this.fr = DATEPICKER_FR;
    this.initMenuEtape();
    this.initData();
    this.initCustomStore();
    this.mailsBonCfEnvoyesSubscription();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subMailsBonCfEnvoyes);
  }

  mailsBonCfEnvoyesSubscription: () => void = () => {
    this.subMailsBonCfEnvoyes = this.commandesSvc.mailsBonCfEnvoyes$
      .pipe(
        switchMap(bonsCfDTO => {
          return this.gds.search(this.commandesSvc.filterStatusMails(bonsCfDTO));
        }),
        switchMap(response => {
          this.commandesSvc.updateStatusBonsCommandesFromRefresh(response.resultList, this.commandesReceptionnees, true);
          return of(response.resultList);
        }),
        switchMap((mailsEnvoyes) => this.commandesSvc.refreshStatusMailsPeriodically(mailsEnvoyes, this.commandesReceptionnees))
      )
      .subscribe(response => {
        const mails = _uniqBy(response.resultList, mail => mail.extraInfos);
        this.commandesSvc.updateStatusBonsCommandesFromRefresh(mails, this.commandesReceptionnees, false);
        this.grid.instance.refresh();
      });
  };

  checkDisabledButtons = (): void => {
    this.grid.instance.getSelectedRowKeys()
      .then(rowsSelected => {
        this.isActionDisabled = rowsSelected.length === 0;
      });
  }

  initCustomStore = (): void => {
    this.dataSource = new CustomStore({
      key: 'id',
      load: (loadOptions: any) => {
        const pageSize: number = loadOptions.take || this.grid.instance.pageSize();
        const page: number = this.grid.instance.pageIndex();
        const sorts: Sort[] = this.dxSvc.dxToGrsSorts(loadOptions.sort);
        const ssWrapper = new SearchSupplierWrapper();
        const filters: FilterItem[] = this.dxSvc.dxToGrsFilters(loadOptions.filter);

        ssWrapper.filtersMap['statutCode'] = new SearchSupplier(BCF_STATUT.COMMANDE_RECEPTIONNEE);
        if (this.numeroCommandeSelected)
          ssWrapper.filtersMap['numeroBcf'] = new SearchSupplier(this.numeroCommandeSelected);
        if (this.articleFilter)
          ssWrapper.filtersMap['article'] = new SearchSupplier(this.articleFilter);
        if (this.bonLivraisonOrReceptionNumeroFilter)
          ssWrapper.filtersMap['bonLivraisonOrReceptionNumero'] = new SearchSupplier(this.bonLivraisonOrReceptionNumeroFilter);
        if (!this.utils.isCollectionNullOrEmpty(this.filterDatesLivraisons)) {
          const startDate = this.filterDatesLivraisons[0].getTime();
          let stopDate = _cloneDeep(startDate);
          if (this.filterDatesLivraisons[1]) {
            stopDate = this.filterDatesLivraisons[1].getTime();
          }
          ssWrapper.filtersMap['startDateLivraison'] = new SearchSupplier(startDate);
          ssWrapper.filtersMap['stopDateLivraison'] = new SearchSupplier(stopDate);
        }

        if (this.listesBesoinsIdsSelected && this.listesBesoinsIdsSelected.length)
          ssWrapper.filtersMap['listesBesoins'] = new SearchSupplier(undefined, this.listesBesoinsIdsSelected);
        if (this.udpIdsSelected && this.udpIdsSelected.length)
          ssWrapper.filtersMap['udps'] = new SearchSupplier(undefined, this.udpIdsSelected);
        if (this.fournisseursIdsSelected && this.fournisseursIdsSelected.length)
          ssWrapper.filtersMap['ffs'] = new SearchSupplier(undefined, this.fournisseursIdsSelected);

        let urlPaginationParams = this.gds.getUrlPaginationParamsFromDataGridDx(pageSize, page, sorts);
        if (loadOptions && loadOptions.select && loadOptions.select[0] === 'id' && this.selectAll) {
          // Si je coche tout => Il faut omettre la pagination
          urlPaginationParams = this.gds.getUrlPaginationParamsFromDataGridDx(null, null, sorts);
        }

        return this.commandesSvc.searchCommandes(ssWrapper, urlPaginationParams).toPromise().then(response => {
          this.commandesReceptionnees = response.resultList;

          const resultSelectedRows = this.dxSvc.getRowsSelectedForDeferredMode(filters, response.resultList);
          if (resultSelectedRows) { return resultSelectedRows; }
          this.initGefAuditData();

          return {
            data: response.resultList,
            totalCount: response.totalElements
          }
        });
      },
      update: (key, values) => { return null; }
    });
  }


  initData = (): void => {
    this.commandesSvc.getFilterItemsListeBesoin(BCF_STATUT.COMMANDE_RECEPTIONNEE).subscribe(response => {
      this.filterItemsListeBesoin = response.resultList;
    });

    this.commandesSvc.getFilterItemsUdp(BCF_STATUT.COMMANDE_RECEPTIONNEE).subscribe(response => {
      this.filterItemsUdp = response.resultList;
    });

    this.commandesSvc.getFilterItemsFfs(BCF_STATUT.COMMANDE_RECEPTIONNEE).subscribe(response => {
      this.filterItemsFournisseur = response.resultList;
    });
  };

  initGefAuditData() {
    if (this.auth2Svc.hasFeature(this.auth2Svc.utilisateur, HAS_GEF)) {
      this.bonCfSvc.findGefAuditData(this.commandesReceptionnees.map(bcf => bcf.id)).subscribe(response => {
        this.gefAuditListBonCommande = response.allGefAuditList;
      });
      this.bonReceptionSvc.findGefAuditData(this.commandesReceptionnees.reduce((acc, bcf) => acc.concat(bcf.bonReceptionList), []).map(br => br.id))
        .subscribe(response => {
          this.gefAuditListBonReception = response.allGefAuditList;
        });
    }
  }

  onChangeFilterDateLivraison = (): void => {
    if (this.grid)
      this.grid.instance.refresh();
  };

  onChangeFilterFournisseurs = ($event): void => {
    if (this.grid) {
      this.fournisseursIdsSelected = $event.value;
      this.grid.instance.refresh();
    }
  };

  onChangeFilterUdps = ($event): void => {
    if (this.grid) {
      this.udpIdsSelected = $event.value;
      this.grid.instance.refresh();
    }
  };

  onChangeFilterListesBesoins = ($event): void => {
    if (this.grid) {
      this.listesBesoinsIdsSelected = $event.value;
      this.grid.instance.refresh();
    }
  };

  onChangeFilterNumCommande = async($event: any): Promise<void> => {
    if (this.grid) {
      this.numeroCommandeSelected = $event.value;
      await this.grid.instance.refresh();
    }
  };

  onChangeFilterArticles = async ($event): Promise<void> => {
    if (this.grid) {
      this.articleFilter = $event.value;
      await this.grid.instance.refresh();
    }
  }

  onChangeFilterBonLivraisonOrReceptionNumero = async ($event): Promise<void> => {
    if (this.grid) {
      this.bonLivraisonOrReceptionNumeroFilter = $event.value;
      await this.grid.instance.refresh();
    }
  }

  initMenuEtape = (): void => {
    this.nextSteps = [
      {
        label: `Passer les commandes sélectionnées à l'étape suivante :`,
        items: [
          {
            label: 'Facturées',
            icon: 'fas fa-angle-double-right',
            command: (event) => this.updateToCommanToNextStep(BCF_STATUT.COMMANDE_FACTUREE)
          }
        ]
      }
    ];
  };

  updateToCommanToNextStep = (statut: string): void => {
    this.grid.instance.getSelectedRowKeys()
      .then(rowsSelected => {
        const selectedBonCfs: BonCfDTO[] = rowsSelected.map(id => this.commandesReceptionnees.find(p => id === p.id));
        this.commandesSvc.updateCommandesStatut(selectedBonCfs.map(b => b.id), statut).subscribe(response => {
          if (!this.utils.isResponseSupplierError(response)) {
            this.grid.instance.refresh();
          }
        });
      });
  };

  openObject = (bonCf: BonCfDTO): void => {
    this.bonCf = undefined;
    this.commandesSvc.findDetailsFromBonCf(bonCf.id).subscribe(response => {
      this.lignesBonCf = [];
      if (!this.utils.isResponseSupplierError(response)) {
        this.displayEditDialog = true;
        this.dialogTitle = this.commandesSvc.getCfTitle(bonCf);
        this.lignesBonCf = response.one.details;
        this.bonCf = _cloneDeep(bonCf);
      }
    });
  };

  printPDFCommandes = (): void => {
    this.grid.instance.getSelectedRowKeys()
      .then(rowsSelected => {
        const selectedBonCfs: BonCfDTO[] = rowsSelected.map(id => this.commandesReceptionnees.find(p => id === p.id));
        this.commandesSvc.printPDFCommandes(selectedBonCfs).subscribe(response => {
          let blob = new Blob([response], {type: 'application/pdf'});
          fs_saveAs(blob, 'commandes-receptionnees.pdf');
        });
      });
  };

  chooseBrlAction: (menu: Menu, $event, bonReception: BonReceptionDTO) => void = (menu: Menu, $event, bonReception: BonReceptionDTO) => {
    this.selectedBonReception = bonReception;
    menu.model[1].label = `Corriger la réception`;
    menu.model[1].disabled = this.utils.isNullOrEmpty(this.selectedBonReception.receptionStatut)
      || !(this.selectedBonReception.receptionStatut.code === RECEPTION_STATUT.RECEPTION_PARTIELLE || this.selectedBonReception.receptionStatut.code === RECEPTION_STATUT.TERMINE)
      || this.selectedBonReception.invoiceStatut === 'SOLDEE';
    menu.show($event);
  };

  getMontantReceptionHT = (bonCfDTO: BonCfDTO): number => {
    if (bonCfDTO.bonReceptionList.length === 0) {
      return 0;
    } else {
      return bonCfDTO.montantHTReception + bonCfDTO.francoDePortReception;
    }
  };

  help = (): undefined => undefined;

  isDisabledGoBackToCommandeAReceptionner = (): void => {
    this.grid.instance.getSelectedRowKeys()
      .then(rowsSelected => {
        let isDisabled = false;
        if (rowsSelected.length) {
          const selectedBonCfs: BonCfDTO[] = rowsSelected.map(id => this.commandesReceptionnees.find(p => id === p.id));
          selectedBonCfs.forEach(bcf => {
            let isMovableBcf = false;
            bcf.bonReceptionList.forEach(br => {
              if (br.receptionStatut.code !== this.receptionStatutCode.TERMINE) {
                isMovableBcf = true;
              }
            });
            if (!isMovableBcf) {
              isDisabled = true;
            }
          });
        } else {
          isDisabled = true;
        }
        this.isDisabledGobackOption = isDisabled;
        this.initMenuEtape();
      });
  };

  openHistoriqueMails = (bonCf: BonCfDTO): void => this.bonCfSvc.announceHistoriqueMailBonCf(bonCf);

  onBonCommandSaved = (): void => {
    this.grid.instance.refresh();
  };

  onDateFilterValueChange = (dates):void => {
    this.filterDatesLivraisons = dates
    this.onChangeFilterDateLivraison();
  };

  cellClick = (e: any) => this.selectAll = (e.rowType === 'header');

  isConditionneParInError(data) {
    return data.details.some(detail => detail.conditionnePar && detail.conditionnePar > 0 && this.utils.modulo(detail.quantiteACommanderAjustee, detail.conditionnePar) != 0)
  }

  isMinimumCommandInError(data) {
    return data.details.some(detail => detail.quantiteACommanderAjustee < detail.minimumDeCommande);
  }

  isFraisPortApplyed(data) {
    return this.bonCfDetailSvc.computeFrancoDePort(data, data.details);
  }

  isHorsDelai(data) {
    return data.details.some(detail => detail.horsDelai);
  }

  onEmailHistoRretreived(emailHisto : MailHistoDTO) {
    this.commandesReceptionnees.find(ligne => ligne.code === emailHisto.extraInfos).mailHisto = emailHisto;
  }

  async cancelBonReception() {
    const hasInvoiceWaiting = this.selectedBonReception.invoiceStatut === 'EN_ATTENTE_VALIDATION';
    const invoiceWarning = hasInvoiceWaiting ? `<br>Une facture fournisseur rattachée à ce bon de réception sera supprimée.` : '';
    const result = confirm(`Êtes-vous sûr de vouloir corriger le bon de réception ?${invoiceWarning}`, 'Correction du bon de réception');
    const isCancelConfirmed: boolean = await result;
    if (isCancelConfirmed) {
      const delete$ = hasInvoiceWaiting ? this.factuSvc.deleteInvoiceByBonReception(this.selectedBonReception.id) : of(null);
      delete$.pipe(
        switchMap(() => this.bonReceptionSvc.cancelBonReception(this.selectedBonReception.id))
      ).subscribe(async (response) => {
        if (response.inError) {
          const msgWarning: string = this.i8nSvc.getLabelFromCode(response.resultList[0].code, [], 'fr');
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, msgWarning);
        } else {
          await this.dataSource.load();
          await this.grid.instance.refresh();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Annulation du bon de réception "${this.selectedBonReception.numeroBonReception}" réussie avec succès`);
        }
      });
    }
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
